<mat-tab-group class="d-none d-sm-flex mat-vertical-tab" mat-align-tabs="start" animationDuration="0ms">
  <mat-tab *ngFor="let group of patientInfo$ | async" [label]="group.label">
    <mat-action-list>
      <ng-container *ngFor="let info of group.value">
        <ng-container *ngTemplateOutlet="listItem; context: { info: info }"></ng-container>
      </ng-container>
    </mat-action-list>
  </mat-tab>
</mat-tab-group>

<mat-action-list class="d-sm-none">
  <ng-container *ngFor="let group of patientInfo$ | async">
    <div mat-subheader>{{ group.label }}</div>
    <ng-container *ngFor="let info of group.value">
      <ng-container *ngTemplateOutlet="listItem; context: { info: info }"></ng-container>
    </ng-container>
  </ng-container>
</mat-action-list>

<ng-template #listItem let-info="info">
  <ng-container *ngIf="info.value">
    <ng-container *ngIf="info.type">
      <a [href]="(info.type === 'phone' ? 'tel:' : 'mailto:') + info.value" mat-list-item>
        <mat-icon matListIcon>{{ info.icon }}</mat-icon>
        <h3 mat-line>{{ info.value }}</h3>
        <small mat-line>{{ info.label }}</small>
      </a>
    </ng-container>
    <ng-container *ngIf="!info.type">
      <mat-list-item disabled>
        <mat-icon *ngIf="info.icon === 'weight'" matListIcon svgIcon="weight"></mat-icon>
        <mat-icon *ngIf="info.icon !== 'weight'" matListIcon>{{ info.icon }}</mat-icon>
        <h3 mat-line>{{ info.value }}</h3>
        <small mat-line>{{ info.label }}</small>
      </mat-list-item>
    </ng-container>
  </ng-container>

  <button mat-list-item *ngIf="!info.value" (click)="editPatient()">
    <mat-icon matListIcon>add_circle_outline</mat-icon>
    <h3 mat-line>Add {{ info.label | lowercase }}</h3>
  </button>
</ng-template>